var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwesomeIdBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-id-badge",
    "data-name": "Icon awesome-id-badge",
    d: "M15.75,0H2.25A2.251,2.251,0,0,0,0,2.25v19.5A2.251,2.251,0,0,0,2.25,24h13.5A2.251,2.251,0,0,0,18,21.75V2.25A2.251,2.251,0,0,0,15.75,0Zm-9,1.5h4.5a.75.75,0,0,1,0,1.5H6.75a.75.75,0,0,1,0-1.5ZM9,7.5a3,3,0,1,1-3,3A3,3,0,0,1,9,7.5Zm5.25,11.1a.983.983,0,0,1-1.05.9H4.8a.983.983,0,0,1-1.05-.9v-.9A2.952,2.952,0,0,1,6.9,15h.234a4.828,4.828,0,0,0,3.731,0H11.1a2.952,2.952,0,0,1,3.15,2.7Z",
    fill: "#a6a6a6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeIdBadge);
export default __webpack_public_path__ + "static/media/awesome-id-badge.31c9b56854f9a1a89445a55222530823.svg";
export { ForwardRef as ReactComponent };